import React, { useMemo } from "react";
import "./style.css";

const AutocompleteInput = ({
  onChange,
  value,
  data = [],
  compareKey = "value",
  valueKey = "value",
  labelKey = "label",
  queryValue = "",
  maxSuggestionCount = 20,
  onSelect,
}) => {
  const suggestions = useMemo(() => {
    if (!queryValue.trim()) {
      return [];
    }

    let count = 0;
    const list = [];

    for (let item of data) {
      const _data = item[compareKey] || "";

      if (_data.toLowerCase().includes(queryValue.toLowerCase())) {
        list.push(item);
        count++;
      }

      if (count === maxSuggestionCount) {
        break;
      }
    }

    return list;
  }, [data, queryValue]);
  const showSuggestions = !!suggestions.length;

  return (
    <div style={{ position: "relative" }}>
      <input className="autocomplete-input" onChange={onChange} value={value} />
      {showSuggestions && (
        <div className="autocomplete-suggestion-list-container">
          {suggestions.map((item) => (
            <div
              key={item[valueKey]}
              onClick={() => {
                if (onSelect) {
                  onSelect(item);
                }
              }}
              className="autocomplete-suggestion-item-container"
            >
              <p className="autocomplete-suggestion-item-text">
                {item[labelKey]}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AutocompleteInput;
